import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {RouterLink} from '@angular/router';

// Renamed from homey-admin-app's NewWindowLinkComponent: despite the old
// name, this has always been a plain in-app routerLink, not a new-window link.
@Component({
  selector: 'homey-user-link',
  imports: [RouterLink],
  templateUrl: './user-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserLinkComponent {
  public readonly id = input.required<string>();
  public readonly base = input<string>('/users');
}
